import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { runtime, STORE } from "@/config";

const SettingsContext = createContext(null);
export const useSettings = () => useContext(SettingsContext);

const FALLBACK = {
  whatsapp_number: runtime.waNumber,
  phone: STORE.phone,
  address: STORE.address,
  hours: STORE.hours,
  upi_id: STORE.upiId,
  upi_name: STORE.upiName,
  qr_image: STORE.qrImage,
  logo: STORE.logo,
  instagram: "",
  facebook: "",
  youtube: "",
};

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(FALLBACK);

  const refresh = () =>
    api.get("/settings").then((r) => {
      const s = { ...FALLBACK, ...r.data };
      setSettings(s);
      runtime.waNumber = s.whatsapp_number || runtime.waNumber;
    }).catch(() => {});

  useEffect(() => { refresh(); }, []);

  return <SettingsContext.Provider value={{ settings, refresh }}>{children}</SettingsContext.Provider>;
};
